import request from './request'

export function listStaff(data) {
  return request.post('/mes/staffs/list', data)
}
export function selectStaff() {
  return request.get('/mes/staffs/select')
}
export function getStaff(id) {
  return request.get('/mes/staffs/' + id)
}
export function saveStaff(data) {
  return request.post('/mes/staffs', data)
}
export function updateStaff(data) {
  return request.post('/mes/staffs/update', data)
}
export function deleteStaff(ids) {
  return request.post('/mes/staffs/delete', ids)
}
export function selectCompany() {
  return request.get('/mes/companies/select')
}
export function selectWageGroup() {
  return request.get('/mes/wage-groups/select')
}
export function selectCrew() {
  return request.get('/mes/crews/select')
}
